import { render, staticRenderFns } from "./ProvinceCitySelect.vue?vue&type=template&id=5ebc4a4c"
import script from "./ProvinceCitySelect.vue?vue&type=script&lang=js"
export * from "./ProvinceCitySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports